// FILE: src/Components/Unsubscribe.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Spin } from 'antd';

export default function Unsubscribe() {
const [searchParams] = useSearchParams();
const navigate = useNavigate();
const [statusText, setStatusText] = useState('Processing unsubscribe request...');

useEffect(() => {
const performUnsubscribe = async () => {
const token = searchParams.get('token');
const type = searchParams.get('type') === 'marketing' ? 'marketing' : 'transactional';

if (!token) {
setStatusText('Invalid unsubscribe link.');
setTimeout(() => navigate('/unsubscribe-error'), 1200);
return;
}

try {
await axios.get(`${process.env.REACT_APP_BACKEND_API}/user/unsubscribe/${type}`, {
params: {
token,
format: 'json',
},
headers: {
Accept: 'application/json',
},
});

setStatusText('You have been unsubscribed.');
setTimeout(() => navigate('/unsubscribed-successfully'), 1000);
} catch (error) {
console.error('Unsubscribe failed:', error);
setStatusText(error.response?.data?.message || 'Unable to process unsubscribe request.');
setTimeout(() => navigate('/unsubscribe-error'), 1500);
}
};

performUnsubscribe();
}, [searchParams, navigate]);

return (
<div className="min-h-screen flex items-center justify-center bg-white px-4">
<div className="text-center">
<Spin size="large" />
<p className="mt-4 text-sm text-gray-600">
{statusText}
</p>
</div>
</div>
);
}